import { HELP_TEXTS } from '../config/prefill';

export function initHelpSections(): void {
  const headings = document.querySelectorAll<HTMLElement>('[data-help-key]');

  headings.forEach((heading) => {
    const key = heading.dataset.helpKey;
    if (!key) return;

    const text = HELP_TEXTS[key];
    if (!text) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'help-block collapsed';

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'help-toggle';
    button.textContent = 'Mostrar ajuda';

    const content = document.createElement('div');
    content.className = 'help-content';
    content.textContent = text;

    button.addEventListener('click', () => {
      const isCollapsed = wrapper.classList.toggle('collapsed');
      button.textContent = isCollapsed ? 'Mostrar ajuda' : 'Ocultar ajuda';
    });

    wrapper.appendChild(button);
    wrapper.appendChild(content);

    heading.insertAdjacentElement('afterend', wrapper);
  });
}